
import React from 'react';

interface PreviewHeaderProps {
  isLoading: boolean;
  previewError?: string | null;
}

export const PreviewHeader = ({ isLoading, previewError }: PreviewHeaderProps) => {
  return (
    <div className="h-[50px] flex-none p-3 bg-muted/50 border-b w-full flex items-center justify-between">
      <h3 className="text-sm font-medium">Live Preview</h3>
      {isLoading && (
        <div className="text-xs text-muted-foreground flex items-center">
          <div className="h-3 w-3 mr-2 rounded-full border-2 border-primary border-t-transparent animate-spin"></div>
          Rendering preview...
        </div>
      )}
      {previewError && (
        <div className="text-xs text-red-500 flex items-center">
          <div className="h-3 w-3 mr-2 text-red-500">⚠️</div>
          {previewError}
        </div>
      )}
    </div>
  );
};
